import * as React from 'react';
import { useSelector } from 'react-redux';
import { OfferCard } from './OfferCard';
import { selectPromoOffer } from '../../selectors/promoOffersSelection/promoOffersSelector';
import { IApplicationState } from '../../types/redux';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { trackBlockClick } from '../PromoOffersSelection/tracking';

interface IPromoOfferCardContainerProps {
  cardId: number;
  onPromoLabelClick(cardId: number): void;
}

export const PromoOfferCardContainer = ({ cardId, onPromoLabelClick }: IPromoOfferCardContainerProps) => {
  const promoOffer = useSelector((state: IApplicationState) => selectPromoOffer(state, cardId));

  const onPromoModalOpen = React.useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      const clickType = promoOffer.promoInfo.promoType === 'discount' ? 'to_promo_with_discount' : 'to_promo';

      trackBlockClick({ offersIds: [promoOffer.offerId], clickType });
      onPromoLabelClick(cardId);
    },
    [cardId, onPromoLabelClick, promoOffer],
  );

  return (
    <PromoOfferCardContext.Provider value={promoOffer}>
      <OfferCard onPromoModalOpen={onPromoModalOpen} />
    </PromoOfferCardContext.Provider>
  );
};
